import cx from "classnames";
import { Heart } from "common/Heart";
import { SingleLineEditor } from "common/SingleLineEditor";
import React from "react";
import appStyles from "../../App/appStyles.scss";
import { normalBlock } from "../../App/blockSizes.scss";
import styles from "./Masthead.scss";

export const Masthead = ({ title, subtitle, liked, likesCount, onHeartClick }) => (
  <div className={cx(styles.Masthead, normalBlock)}>
    <h1 className={appStyles.title}>{title}</h1>
    {subtitle && (
      <div className={appStyles.subtitle}>
        <SingleLineEditor key={subtitle} defaultValue={subtitle} textAlignment="center" readOnly type="subtitle" />
      </div>
    )}
    <Heart liked={liked} count={likesCount} onClick={onHeartClick} />
  </div>
);
